"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBillingScheduleGroup = exports.isProductTokenGroup = exports.PRODUCT_TOKEN_GROUP = exports.InsertPosition = exports.ReorderDirection = void 0;
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var Token_1 = require("ContentTokens/Token");
var lodash_1 = require("lodash");
var es_toolkit_1 = require("es-toolkit");
var es_toolkit_2 = require("es-toolkit");
var mobx_1 = require("mobx");
var CalculateSection_1 = require("QuoteV2/Calculator/CalculateSection");
var DiscountStore_1 = __importStar(require("./DiscountStore"));
var QuoteItemStore_1 = require("./QuoteItemStore");
var ReorderDirection;
(function (ReorderDirection) {
    ReorderDirection["Up"] = "up";
    ReorderDirection["Down"] = "down";
})(ReorderDirection || (exports.ReorderDirection = ReorderDirection = {}));
var InsertPosition;
(function (InsertPosition) {
    InsertPosition["Before"] = "before";
    InsertPosition["After"] = "after";
})(InsertPosition || (exports.InsertPosition = InsertPosition = {}));
exports.PRODUCT_TOKEN_GROUP = "product-token-group";
var isProductTokenGroup = function (group) { return group === exports.PRODUCT_TOKEN_GROUP; };
exports.isProductTokenGroup = isProductTokenGroup;
var isBillingScheduleGroup = function (group) { return !(0, exports.isProductTokenGroup)(group); };
exports.isBillingScheduleGroup = isBillingScheduleGroup;
var QuoteSectionStore = (function () {
    function QuoteSectionStore(angularSection, currency, services) {
        var _a, _b, _c, _d, _e;
        this.currency = currency;
        this.services = services;
        this._id = (_a = angularSection.$id) !== null && _a !== void 0 ? _a : (0, UniqueId_1.default)();
        this._displayMode = angularSection.displayMode;
        this._angularSection = (0, lodash_1.cloneDeep)(angularSection);
        this._items = this._angularSection.items.map(function (item) { return (0, QuoteItemStore_1.createQuoteItemStore)(item, currency, services); });
        this._discount = new DiscountStore_1.default((_b = this._angularSection.discount) !== null && _b !== void 0 ? _b : DiscountStore_1.defaultDiscount);
        this._showSubtotal = this._angularSection.viewSettings.showSubtotal;
        this._collapsed = this._angularSection.viewSettings.itemsCollapsed;
        this._showFeatureList = angularSection.viewSettings.showFeatureList;
        this._groupItemsByBillingSchedule = angularSection.viewSettings.groupItemsByBillingSchedule;
        this._mandatory = (_c = this._angularSection.mandatory) !== null && _c !== void 0 ? _c : false;
        this._itemSingleSelect = angularSection.itemSingleSelect;
        this._showItemDescription = this._angularSection.viewSettings.itemsViewable;
        this._showItemPrice = this._angularSection.viewSettings.showCost;
        this._showItemRate =
            (_d = this._angularSection.viewSettings.showRate) !== null && _d !== void 0 ? _d : this._angularSection.viewSettings.showRateAndQuantity;
        this._showItemQuantity =
            (_e = this._angularSection.viewSettings.showQuantity) !== null && _e !== void 0 ? _e : this._angularSection.viewSettings.showRateAndQuantity;
    }
    Object.defineProperty(QuoteSectionStore.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "displayMode", {
        get: function () {
            var _a;
            return (_a = this._displayMode) !== null && _a !== void 0 ? _a : Types_1.QuoteSectionDisplayMode.Table;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "itemSingleSelect", {
        get: function () {
            var _a;
            return (_a = this._itemSingleSelect) !== null && _a !== void 0 ? _a : false;
        },
        set: function (enabled) {
            var _this = this;
            (0, lodash_1.drop)(this.items.filter(function (item) { return item instanceof QuoteItemStore_1.QuotePricedItemStore && item.isOptional && item.isOptionalSelected; }), 1).forEach(function (item) {
                _this.toggleItemSelection(item);
            });
            this._itemSingleSelect = enabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showFeatureList", {
        get: function () {
            var _a;
            return (_a = this._showFeatureList) !== null && _a !== void 0 ? _a : false;
        },
        set: function (show) {
            this._showFeatureList = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "groupByBillingSchedule", {
        get: function () {
            var _a;
            return (_a = this._groupItemsByBillingSchedule) !== null && _a !== void 0 ? _a : false;
        },
        set: function (enableGrouping) {
            this._groupItemsByBillingSchedule = enableGrouping;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "selected", {
        get: function () {
            var _a;
            return (_a = this._angularSection.selected) !== null && _a !== void 0 ? _a : false;
        },
        set: function (selection) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this._angularSection.selected = selection;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "mandatory", {
        get: function () {
            return this._mandatory;
        },
        set: function (mandatory) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this._mandatory = mandatory;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showSubtotal", {
        get: function () {
            return this._showSubtotal;
        },
        set: function (showSubtotal) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this._showSubtotal = showSubtotal;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showItemDescription", {
        get: function () {
            return this._showItemDescription;
        },
        set: function (show) {
            this._showItemDescription = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showItemPrice", {
        get: function () {
            return this._showItemPrice;
        },
        set: function (show) {
            this._showItemPrice = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showItemRate", {
        get: function () {
            return this._showItemRate;
        },
        set: function (show) {
            this._showItemRate = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "showItemQuantity", {
        get: function () {
            return this._showItemQuantity;
        },
        set: function (show) {
            this._showItemQuantity = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "collapsed", {
        get: function () {
            return this._collapsed;
        },
        set: function (collapse) {
            this._collapsed = collapse;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "angularModel", {
        get: function () {
            return __assign(__assign(__assign({}, this._angularSection), { items: this._items.map(function (item) { return item.angularModel; }), discount: this._discount.angularModel, mandatory: this.mandatory, viewSettings: __assign(__assign(__assign(__assign({}, this._angularSection.viewSettings), { showSubtotal: this._showSubtotal, showCost: this._showItemPrice, showQuantity: this._showItemQuantity, showRate: this._showItemRate, itemsViewable: this._showItemDescription, itemsCollapsed: this._collapsed }), (!(0, es_toolkit_1.isUndefined)(this._showFeatureList) ? { showFeatureList: this._showFeatureList } : {})), (!(0, es_toolkit_1.isUndefined)(this._groupItemsByBillingSchedule)
                    ? { groupItemsByBillingSchedule: this._groupItemsByBillingSchedule }
                    : {})), $id: this.id }), (!(0, es_toolkit_1.isUndefined)(this._itemSingleSelect) ? { itemSingleSelect: this._itemSingleSelect } : {}));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    QuoteSectionStore.prototype.itemsByGroup = function (group) {
        return this.items.filter(function (item) {
            return (item instanceof QuoteItemStore_1.QuotePricedItemStore &&
                (0, exports.isBillingScheduleGroup)(group) &&
                (0, es_toolkit_2.isEqual)(item.billingSchedule, group)) ||
                (item instanceof QuoteItemStore_1.QuoteProductItemStore && (0, exports.isProductTokenGroup)(group));
        });
    };
    Object.defineProperty(QuoteSectionStore.prototype, "groups", {
        get: function () {
            var schedules = [];
            var hasProductItem = false;
            this.items.forEach(function (item) {
                if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                    var scheduleExists = schedules.filter(function (schedule) { return (0, es_toolkit_2.isEqual)(schedule, item.billingSchedule); }).length > 0;
                    if (!scheduleExists) {
                        schedules.push(item.billingSchedule);
                    }
                }
                if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
                    hasProductItem = true;
                }
            });
            return __spreadArray(__spreadArray([], __read((0, lodash_1.sortBy)(schedules, function (schedule) {
                return (0, lodash_1.indexOf)(Recurrence_1.recurringFrequencyDisplayOrder, (0, Types_1.isRecurringSchedule)(schedule) ? schedule.frequency : null);
            })), false), __read((hasProductItem ? [exports.PRODUCT_TOKEN_GROUP] : [])), false);
        },
        enumerable: false,
        configurable: true
    });
    QuoteSectionStore.prototype.hasGroup = function (group) {
        return this.groups.some(function (existingGroup) { return (0, es_toolkit_2.isEqual)(existingGroup, group); });
    };
    Object.defineProperty(QuoteSectionStore.prototype, "total", {
        get: function () {
            return this.services.calculatorService.calculateSection(this.angularModel, this.currency);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSectionStore.prototype, "description", {
        get: function () {
            return this._angularSection.description;
        },
        enumerable: false,
        configurable: true
    });
    QuoteSectionStore.prototype.addLineItems = function (items, insertRefId, insertPosition) {
        var _a;
        var _this = this;
        var itemsToInsert = (Array.isArray(items) ? items : [items]).map(function (item) {
            return (0, QuoteItemStore_1.createQuoteItemStore)(item, _this.currency, _this.services);
        });
        var insertRefIndex = insertRefId ? this.items.findIndex(function (item) { return item.id === insertRefId; }) : -1;
        var insertIndex = insertRefIndex !== -1 ? insertRefIndex + (insertPosition === InsertPosition.Before ? 0 : 1) : this.items.length;
        (_a = this._items).splice.apply(_a, __spreadArray([insertIndex, 0], __read(itemsToInsert), false));
    };
    QuoteSectionStore.prototype.deleteLineItem = function (item) {
        var index = (0, lodash_1.findIndex)(this.items, function (x) { return x.id === item.id; });
        this._items.splice(index, 1);
    };
    QuoteSectionStore.prototype.reorderLineItem = function (item, direction) {
        var _a;
        var from = this.items.findIndex(function (x) { return x.id === item.id; });
        var to = (0, lodash_1.clamp)((_a = {},
            _a[ReorderDirection.Up] = from - 1,
            _a[ReorderDirection.Down] = from + 1,
            _a)[direction], 0, this.items.length - 1);
        this._items.splice(from, 1);
        this._items.splice(to, 0, item);
    };
    Object.defineProperty(QuoteSectionStore.prototype, "discount", {
        get: function () {
            return this._discount;
        },
        enumerable: false,
        configurable: true
    });
    QuoteSectionStore.prototype.toggleItemSelection = function (item) {
        var e_1, _a;
        if (this.itemSingleSelect) {
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var siblingItem = _c.value;
                    if (siblingItem !== item && (0, QuoteItemStore_1.supportsInteractivePricing)(siblingItem)) {
                        siblingItem.isOptionalSelected = false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if ((0, QuoteItemStore_1.supportsInteractivePricing)(item)) {
            item.isOptionalSelected = !item.isOptionalSelected;
        }
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof Types_1.QuoteSection !== "undefined" && Types_1.QuoteSection) === "function" ? _a : Object)
    ], QuoteSectionStore.prototype, "_angularSection", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], QuoteSectionStore.prototype, "_items", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_b = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _b : Object)
    ], QuoteSectionStore.prototype, "_discount", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showSubtotal", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_mandatory", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showItemDescription", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showItemRate", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showItemQuantity", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showItemPrice", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_collapsed", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_itemSingleSelect", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_showFeatureList", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteSectionStore.prototype, "_groupItemsByBillingSchedule", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "itemSingleSelect", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showFeatureList", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "groupByBillingSchedule", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "selected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "mandatory", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showSubtotal", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showItemDescription", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showItemPrice", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showItemRate", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "showItemQuantity", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteSectionStore.prototype, "collapsed", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "angularModel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "items", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "groups", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof CalculateSection_1.CalculatedSection !== "undefined" && CalculateSection_1.CalculatedSection) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "total", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "description", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, String, String]),
        __metadata("design:returntype", void 0)
    ], QuoteSectionStore.prototype, "addLineItems", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof QuoteItemStore_1.QuoteItemStore !== "undefined" && QuoteItemStore_1.QuoteItemStore) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteSectionStore.prototype, "deleteLineItem", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof QuoteItemStore_1.QuoteItemStore !== "undefined" && QuoteItemStore_1.QuoteItemStore) === "function" ? _g : Object, String]),
        __metadata("design:returntype", void 0)
    ], QuoteSectionStore.prototype, "reorderLineItem", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_h = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _h : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSectionStore.prototype, "discount", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof QuoteItemStore_1.QuoteItemStore !== "undefined" && QuoteItemStore_1.QuoteItemStore) === "function" ? _j : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteSectionStore.prototype, "toggleItemSelection", null);
    return QuoteSectionStore;
}());
exports.default = QuoteSectionStore;
